import { transformIcon } from '@/helpers/transforms'
import type { RoadmapBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import type { RoadmapPhaseType } from '../atoms/RoadmapPhaseItem'
import { RoadMapBlock } from '../blocks/RoadMapBlock'

export const RoadMapConverter: JSXConverter<SerializedBlockNode<RoadmapBlock>> = ({ node }) => {
	const { phases } = node.fields

	const itemsData = (phases ?? []).reduce<RoadmapPhaseType[]>((acc, phase) => {
		const { icon, label } = phase
		const iconData = transformIcon(icon)

		if (iconData) {
			acc.push({
				id: phase.id,
				icon: iconData,
				title: label,
			} satisfies RoadmapPhaseType)
		}

		return acc
	}, [])

	return <RoadMapBlock roadmap={itemsData} />
}
